import React, { useEffect, useState } from "react";
import "./login.css";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { useAuth } from "../../context/AuthContext";
import { primeSpeech } from "../../utils/speak";
import { useNavigate } from "react-router-dom";
import Seo from "../Seo/Seo";

export default function LoginFullBg() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [showPwd, setShowPwd] = useState(false);
  const [form, setForm] = useState({ login: "", password: "", remember: false });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    primeSpeech(); // débloque la voix dans le geste (avant l'appel réseau)
    try {
      // backend attend { nom, password } => mappé dans AuthContext.login
      await login({ login: form.login, password: form.password });
      navigate("/espace", { replace: true });
    } catch (err) {
      setError(err.message || "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  // Supprime le padding-top global du body quand on est sur /login
  useEffect(() => {
    document.body.classList.add("no-header-padding");
    return () => document.body.classList.remove("no-header-padding");
  }, []);

  return (
    <main className="login-bg" role="main">
      <Seo title="Connexion espace professionnel" path="/login"
        description="Connectez-vous à votre espace professionnel Amen Distribution pour commander vos pièces auto en ligne." />
      <div className="bg-overlay" aria-hidden />
      <section className="panel glow-border" role="dialog" aria-labelledby="login-title">
        <header className="panel-header">
          <h1 id="login-title">Connexion</h1>
          <p className="subtitle">B2B Auto-Pièces • AMENE DISTRIBUTION • MG</p>
        </header>

        <form className="form" onSubmit={handleSubmit}>
          <label className="label" htmlFor="login">Identifiant</label>
          <div className="field">
            <svg className="icon" viewBox="0 0 24 24" aria-hidden>
              <path fill="currentColor" d="M12 12a5 5 0 1 0-5-5a5 5 0 0 0 5 5Zm0 2c-4.418 0-8 2.239-8 5v1h16v-1c0-2.761-3.582-5-8-5Z" />
            </svg>
            <input
              id="login"
              name="login"

              autoComplete="username"
              placeholder="ex: 00000"
              value={form.login}
              onChange={handleChange}
              required
            />
          </div>

          <label className="label" htmlFor="password">Mot de passe</label>
          <div className="field">
            <svg className="icon" viewBox="0 0 24 24" aria-hidden>
              <path fill="currentColor" d="M17 8V7a5 5 0 1 0-10 0v1H5v14h14V8h-2Zm-8 0V7a3 3 0 1 1 6 0v1H9Zm3 5a2 2 0 1 1 0 4a2 2 0 0 1 0-4Z" />
            </svg>
            <input
              id="password"
              name="password"
              type={showPwd ? "text" : "password"}
              autoComplete="current-password"
              placeholder="••••••••"
              value={form.password}
              onChange={handleChange}
              required
            />
            <button
              type="button"
              onClick={() => setShowPwd(s => !s)}
              aria-label={showPwd ? "Masquer le mot de passe" : "Afficher le mot de passe"}
              style={{ background: "transparent", border: "none", padding: 6, lineHeight: 0, cursor: "pointer", color: "#fff" }}
              onMouseDown={e => e.preventDefault()}
            >
              {showPwd ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <div className="row">
            <label className="remember">vous n'arrivez pas à vous connecter ?</label>
            <a
              className="link"
              href={`mailto:contact@amenedistribution.com?subject=${encodeURIComponent(
                "Problème de connexion - CRM"
              )}`}
            >
              Contactez Nous
            </a>

          </div>


          {error && <div style={{ color: "#ffb4b4", fontSize: 13, marginTop: 6 }}>{error}</div>}

          <button className="btn-primary" type="submit" disabled={loading}>
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>

        <footer className="panel-footer">© 2025 — Business Software</footer>
      </section>
    </main>
  );
}
